import {Routes} from "@angular/router";
import {WorkflowPartnerOneTrialCreateComponent} from "./workflow-partner-one-trial-create.component";


export const workflowPartnerOneTrialCreateRouting: Routes = [
  {
    path: 'partner/one-trial', component: WorkflowPartnerOneTrialCreateComponent, children: [
      {path: 'customer', component: WorkflowPartnerOneTrialCreateComponent},
      {path: 'contact', component: WorkflowPartnerOneTrialCreateComponent},
      {path: 'trial-phonenumber', component: WorkflowPartnerOneTrialCreateComponent},
      {path: 'instance', component: WorkflowPartnerOneTrialCreateComponent},
      {path: 'phonenumber', component: WorkflowPartnerOneTrialCreateComponent},
      {path: 'thank-you', component: WorkflowPartnerOneTrialCreateComponent},
      {path: '', redirectTo: 'customer', pathMatch: 'full'},
    ]
  },
]
